export default {"src":"/_next/static/media/germany.0284a60e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};